<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <label *ngIf="!hideLabel" [for]="formId" class="trim-text">
      {{ label }}
      <span
        *ngIf="inputForm.controls['date'].errors?.['required'] || inputForm.controls['time'].errors?.['required']">
        *
      </span>
    </label>
    <app-dropdown #dropdown [disabled]="inputForm.disabled" [removeArrow]="true" (openChange)="initCalendar()"
                  [openDropdownUpwards]="openDropdownUpwards"  [leftAlign]="leftAlign" (dropdownClosed)="dropdownClosed($event)">
      <div dropdownPanel>
        <div class="input-group" dropdownToggle>
          <input [id]="formId" [value]="getStringValue()" [disabled]="inputForm.disabled" [ngClass]="{'error': hasErrors() && isTouched(), 'disabled': inputForm.disabled,
               'ng-touched': isTouched(),'ng-invalid ': hasErrors() && isTouched()}"
                 class="form-control date-input date-input-with-label input-large" readonly/>
          <button class="btn btn-outline-secondary" type="button" [disabled]="inputForm.disabled"
                  [ngClass]="{'button-error': hasErrors() && isTouched()}">
            <img src="assets/icons/icons-alt/notifications.svg" alt="Calendar">
          </button>
        </div>
      </div>
      <div dropdownContent>
        <div>
          <div class="px-2 py-2">
            <div class="calendar-controls d-flex align-items-center justify-content-between">
              <div class="btn-circle me-2 navigate" (click)="navigatePrevious()"
                   [ngStyle]="{'visibility': calendarState === CalendarState.MONTH ? 'hidden' : 'visible'}">
                <i class="scale-80 bi bi-chevron-left"></i>
              </div>

              <div class="d-flex justify-content-center">
                <button class="navigator-button" (click)="changeCalendarState(CalendarState.MONTH)"
                        [ngClass]="{'selected': calendarState === CalendarState.MONTH }">
                  {{
                    t("app.common.month." + navigationDate.month)
                  }}
                </button>
                <button class="navigator-button" (click)="changeCalendarState(CalendarState.YEAR)"
                        [ngClass]="{'selected': calendarState === CalendarState.YEAR }">
                  {{ navigationDate.year }}
                </button>
              </div>
              <div class="btn-circle ms-2 navigate" (click)="navigateNext()"
                   [ngStyle]="{'visibility': calendarState === CalendarState.MONTH ? 'hidden' : 'visible'}">
                <i class="scale-80 bi bi-chevron-right"></i>
              </div>
            </div>
          </div>
          <div>
            @if (calendarState === CalendarState.YEAR) {
              <div class="container">
                <div class="row row-cols-3">
                  @for (navigation of years;track navigation) {
                    <div class="col p-2">
                      <div (click)="!navigation.disabled ? yearSelected($event, (navigation.value)): null"
                           class="picker btn-light"
                           [ngClass]="{'bg-primary text-white': navigationDate.year === navigation.value,
                           'disabled': navigation.disabled,
                           'current': !(navigationDate.year === navigation.value) && currentDate.getFullYear() === navigation.value}">
                        {{ navigation.value }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            @if (calendarState === CalendarState.MONTH) {
              <div class="container">
                <div class="row row-cols-3">
                  @for (navigation of months;track navigation) {
                    <div class="col p-2">
                      <div (click)="!navigation.disabled ? monthSelected($event, navigation.value) : null"
                           class="picker btn-light" [ngClass]="{
                           'bg-primary text-white': navigationDate.month === navigation.value,
                           'disabled': navigation.disabled,
                           'current': !(navigationDate.month === navigation.value) &&
                                    currentDate.getFullYear() === navigationDate.year && currentDate.getMonth()+1 === navigation.value
                           }">
                        {{ t("app.common.month." + navigation.value) }}
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            <div [ngStyle]="{'display': calendarState === CalendarState.DAY ? 'block' : 'none'}">
              <ngb-datepicker formControlName="date" [startDate]="navigationDate" [navigation]="'none'" (dateSelect)="onDateSelected($event)"
                              outsideDays="hidden" [markDisabled]="markDisabled" #calendar="ngbDatepicker"/>
            </div>
          </div>
          @if (displayTime) {
            <div class="d-flex align-items-center justify-content-center">
              <ngb-timepicker formControlName="time" [hourStep]="1" [minuteStep]="15" [secondStep]="15"
                              [seconds]="displaySeconds"/>
              @if (displayMilliseconds) {
                <div class="ngb-tp-spacer ng-star-inserted">:</div>
                <div class="ngb-tp-input-container ngb-tp-minute">
                  <button tabindex="-1" type="button" class="btn btn-link ng-star-inserted"><span
                    class="chevron ngb-tp-chevron" (click)="onIncrementMilliseconds(100)"></span><span
                    class="visually-hidden">Increment milliseconds</span>
                  </button>
                  <input formControlName="milliseconds" class="ngb-tp-input form-control">
                  <button tabindex="-1" type="button" class="btn btn-link ng-star-inserted"
                          (click)="onIncrementMilliseconds(-100)"><span
                    class="chevron ngb-tp-chevron bottom"></span><span
                    class="visually-hidden">Decrement milliseconds</span>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </app-dropdown>
    @if (!hideErrorMessage) {
    @if (formControlName && isTouched()) {
      @for (errorMessage of inputForm.errors | errorMessages:formControlName;track errorMessage) {
        <span class="errorMes pt-1">{{ errorMessage }}</span>
      }
      @for (errorMessage of control.errors | errorMessages:formControlName;track errorMessage) {
        <span class="errorMes pt-1">{{ errorMessage }}</span>
      }
    }
    }
  </form>
</ng-container>

